import React from 'react'

function RamaAyutthaya() {
  return (
    <div>ศูนย์การแพทย์รามาศรีอยุธยา</div>
  )
}

export default RamaAyutthaya